export const Modes = {
    ADD: "add",
    EDIT: "edit"
}